@let eula = eula$ | async;
<div class="eula-wrapper">
  <div class="markdown-wrapper">
    @if (eula) {
      <div class="markdown-text" [innerHTML]="eula"></div>
    } @else {
      <div i18n class="placeholder">...loading</div>
    }
  </div>
  <div class="actions">
    <app-button i18n (click)="acceptEula()" [disabled]="!eula">Accept EULA and continue</app-button>
  </div>
</div>
